module.exports = __webpack_public_path__ + "static/media/favorites-icon-active.13c69ae3.svg";